var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgFavoriteIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 15,
    viewBox: "0 0 120 167",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.59229 0.900192L0.633766 3.86494V164.533L5.49889 166.794L60.0015 120.808L114.504 166.794L119.369 164.533V3.86494L116.411 0.900192H3.59229ZM6.57273 6.85166H113.43V158.12L61.9081 114.659H58.0949L6.57273 158.12V6.85166Z",
    fill: "#FFF"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFavoriteIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/favoriteIcon.f879d9be.svg";
export { ForwardRef as ReactComponent };